import React, { useEffect, useRef, useState } from 'react'
import "../styleCss/UserManage.css"
import Header from "../../template/Header.js";
import Menu from "../../template/Menu.js";
import Footer from "../../template/Footer.js";
import Loading from "../../components/loading/Loading";
import { setTimeOutSync } from "../../utils/setTimeout";
import { Col, Row, Form } from "react-bootstrap";
import { getAllRole, createRole, getRoleByID, updateRoleByID} from "../../api/role_api.js";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig.js";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle.js";
import { useNavigate } from 'react-router-dom';
import {
    alertValidateData,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../../components/alertValid/AlertValid.js"

function AddEditRole() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );

    const [isLoading, setLoading] = useState(false);
    const [txtTitleId, setTxtTitleId] = useState();
    const [editId, setEditId] = useState(null);
    const [DataRole, setDataRole] = useState([]);
    const [active, setActive] = useState(true);

    const [selectPermission, setSelectPermission] = useState([]);
    
    const [dataUser, setDataUser] = useState({
        role: null
    });

    const navigate = useNavigate();
    const navigateToBack = (page) => {
      navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }
    const getRoleMenu = async () => {
        try {
            const response = await getAllRole();
            if (response.status == 200) {
                let dataRole = [];
                response.data.data.forEach((item, i) => {
                    dataRole.push({
                        id: item.key,
                        label: item.name,
                        checked:false,
                    });
                });
                if(editId)
                {
                    const responseById = await getRoleByID(editId);
                    if (response.status == 200) {
                        dataRole.forEach(all => {
                            const matchingRole = responseById.data.data.menu_lists.some(byId => byId.key === all.id);
                            if (matchingRole) {
                                all.checked = true;
                            } else {
                                all.checked = false;
                            }
                        });   
                        setDataUser({
                            ...dataUser,
                            role: responseById.data.data.role_name,
                        })
                        setActive(responseById.data.data.active === 1 ? true : false);                      
                    }
                }
                setSelectPermission(dataRole);
            }
        } catch (error) {
            console.log('getRoleMenu',error)
        }
    };

    const createRoleData = async () => {
        let menuList = []
        for(let i=0;i<selectPermission.length;i++)
        {
            if(selectPermission[i].checked)
            {
                menuList.push(selectPermission[i].id)
            }
        }
        let body = {
            "name": dataUser.role, 
            "menu_list": menuList,
            active: active === false ? 0 : 1,
        };
        if (
          body.menu_list.length == 0||!dataUser?.role
        ) {
          await alertValidate();
        } else {
            const result = await alertConfirmSave();
            if (result.isConfirmed) {
              (async () => {
                await setLoading(true);
                const response = await createRole(body);
                setTimeOutSync(() => setLoading(false)).then(async () => {
                  if (response.data.status == "success") {
                    const result = await alertSaved();
                      if (result.isConfirmed) {
                        navigateToBack("/infoRoleManage");
                      }
                  }
                }).finally(() => setLoading(false))
              })();
            }
        }
    };

    const updateRoleData = async (id) => {
        let menuList = []
        for(let i=0;i<selectPermission.length;i++)
        {
            if(selectPermission[i].checked)
            {
                menuList.push(selectPermission[i].id)
            }
        }
        let body = {
            "name": dataUser.role, 
            "menu_list": menuList,
            active: active === false ? 0 : 1,
        };
        if (
          body.menu_list.length == 0||!dataUser?.role
        ) {
          await alertValidate();
        } else {
            const result = await alertConfirmSave();
            if (result.isConfirmed) {
              (async () => {
                await setLoading(true);
                const response = await updateRoleByID(id, body);
                setTimeOutSync(() => setLoading(false)).then(async() => {
                  if (response.data.status == "success") {
                    const result = await alertSaved();
                      if (result.isConfirmed) {
                        navigateToBack("/infoRoleManage");
                      }
                  }
                }).finally(() => setLoading(false))
              })();
            }
        }
    };

    const handleSaveBtn = async () => {
        if (editId) {
            updateRoleData(editId);
        } else {
            createRoleData();
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
          if (res.isConfirmed) {
            navigateToBack("/infoRoleManage");
          }
          else {  }
    };

    
    let apiCalled = useRef(false); // Flag variable

    useEffect(() => {
        if (!apiCalled.current) {
            apiCalled.current = true;
            let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
            // getRoleMenu(id);
            setEditId(id);
            setTxtTitleId(id);
            }
        };
        getRoleMenu();
    }, [apiCalled.current]);
  return (
    <>
    <style>
        {`
            .form-check-input {
                border: var(--bs-border-width) solid #000000 !important;
            }
        `}
    </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"ADMIN USER"} />
        <Menu
            parentmenu={"infoAdminUser"}
            activemenu={"infoRoleManage"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                        {txtTitleId ? (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                            <img src="assets/icons/ic-users.png" className="ic-user01 me-2" alt="" />
                            EDIT ROLE MANAGE
                            </font>
                        ) : (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                            <img src="assets/icons/ic-users.png" className="ic-user01 me-2" alt="" />
                            ADD ROLE MANAGE
                            </font>
                        )}
                        </Col>
                    </Row>
                    <Row className="ms-5">
                        <Col xs={12} className="d-flex align-items-center mt-3 p-0">
                        {editId ? (
                            <p className="mb-0 font-weight-bold fontReg font-size01">
                            Edit User Permission
                            </p>
                        ) : (
                            <p className="mb-0 font-weight-bold fontReg font-size01">
                            Add User Permission
                            </p>
                        )}
                        </Col>
                    </Row>
                    <Row className="ms-5 mt-3 d-flex align-items-center">
                        <Col xs={3} xl={1} className="p-0">
                        <label className="fontLight font-size03 colorBlack01">
                            Role
                        </label>
                        </Col>
                        <Col xs={9} xl={5}>
                        <input
                            type="text"
                            className="inp01 fontLight font-size03"
                            id="role"
                            placeholder="Role"
                            value={dataUser.role}
                            onChange={(event) =>
                            setDataUser({
                                ...dataUser,
                                role: event.target.value,
                            })
                            }
                        />
                        </Col>
                    </Row>
                </div>
                <div className="box-white mt-4">
                    <Row className="ms-5 mb-2">
                        <Col xs={12} className="d-flex align-items-center mt-3 p-0">
                            <p className="mb-0 font-weight-bold fontReg font-size01">
                            Permission
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        {selectPermission.map((data, index) => (
                            <Col xs={6} key={index}>
                                <Form className="ml-5">
                                    <div className="my-2">
                                        <Form.Check
                                            className={data.class}
                                            inline
                                            label={data.label}
                                            name="group1"
                                            type="checkbox"
                                            id={`inline-checkbox-${index}`}
                                            checked={data.checked}
                                            onChange={(event) => {
                                                const updatedPermissions = [...selectPermission]; // Create a copy of the array
                                                updatedPermissions[index] = { ...data, checked: event.target.checked }; // Update the specific element
                                                setSelectPermission(updatedPermissions); // Update the state
                                            }}
                                        />
                                    </div>
                                </Form>
                            </Col>
                        ))}
                    </Row>
                </div>
                <div className='box-white mt-4'>
                    <Row className='ms-5 mt-4'>
                        <Col xs={12} className="p-0">
                            <label className="fontLight font-size03 colorBlack01">
                            Status
                            </label>
                        </Col>
                    </Row>
                    <Form className="ml-5">
                        {["radio"].map((type) => (
                            <div key={`inline3-${type}`} className="mt-2 mb-3">
                            <Form.Check
                                className="fontLight font-size03 colorBlack01 checked"
                                inline
                                label="Active"
                                name="group3"
                                type={type}
                                id={`inline3-${type}-1`}
                                checked={active}
                                onChange={(e) => setActive(true)}
                            />
                            <Form.Check
                                className="fontLight font-size03 colorBlack01"
                                inline
                                label="Inactive"
                                name="group3"
                                type={type}
                                id={`inline3-${type}-2`}
                                checked={!active}
                                onChange={(e) => setActive(false)}
                            />
                            </div>
                        ))}
                    </Form>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                            handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default AddEditRole;